module.exports = __webpack_public_path__ + "img/tiyan.536edddc.png";